import { useEffect, useState } from "react";
import FleetCounter from "../components/Dashboard/fleetCounter";
import FleetSate from "../components/Dashboard/fleetSate";
import Notification from "../components/Dashboard/alerts";
import { useTranslate } from "../hooks/LanguageProvider";
import FleetCo2 from "../components/Dashboard/fleetCo2";
import { Table } from "react-bootstrap";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";


import {
  engineStat,
  BarreReseau,
  ValidatePosition,
  getAddressFromCoordinates,
  formatDateForAlgeriaTimeZone,
} from "../utilities/functions";


const backendUrl = process.env.REACT_APP_BACKEND_URL;
// Définir une interface pour les données de véhicule
interface VehicleData {
  immatriculation_vehicule: string;
  SOG: number;
  GSMLVL: number;
  NST: number;
  psn_dispositif: string;

  // Ajoutez d'autres propriétés si nécessaire
}

export function Dashboard() {
  const { translate } = useTranslate();
  const user_id = localStorage.getItem("userid");
  const [totalDrivers, setTotalDrivers] = useState(0);
  const [totalUsers, setTotalUsers] = useState(0);
  const [totalVehicles, setTotalVehicles] = useState(0);
  const [totalReports, setTotalReports] = useState(0);
  const [userName, setUserName] = useState(localStorage.getItem("username"));
  const [loading, setLoading] = useState(false);
  const [listNotifications, setNotifications] = useState<Notification[]>([]);

  interface SearchResult {
    psn_dispositif: string;
    prenom_user: string;
    nom_conducteur: string;
    prenom_conducteur: string;
    nom_user: string;
    nom_groupe: string;
    immatriculation_vehicule: string;
    SOG: number;
    LAT: number;
    LON: number;
    GPSDIST: number;
    ENGINESTAT: number;
    category_vehicule: string;
    vehicule_type: string;
    TIMESTAMP: string;
    Adresse: string; // Add the address field
  }


  interface Vehicle {
    id_vehicule: number;
    immatriculation_vehicule: string;
    LAT: number;
    LON: number;
    SOG: number;
    COG: number;
    ENGINESTAT: number;
    TIMESTAMP: string;
    GPSDIST: number;
    GSMLVL: number;
    NST: number;
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch total number of drivers
        const responseDrivers = await fetch(
          `${backendUrl}/api/dash/driver/${user_id}`,
          { mode: "cors" }
        );
        if (responseDrivers.ok) {
          const totalDriversData = await responseDrivers.json();
          const totalDriversCount = totalDriversData[0].total;
          setTotalDrivers(totalDriversCount);
         // console.log("drivers:", totalDriversCount);
        } else {
          console.error("Failed to fetch total number of drivers");
        }

        // Fetch total number of vehicle
        const responseVehicles = await fetch(
          `${backendUrl}/api/vehicle/totalpage/${user_id}`,
          { mode: "cors" }
        );
        if (responseVehicles.ok) {
          const totalVehiclesData = await responseVehicles.json();
          const totalVehiclesCount = totalVehiclesData[0].total;
          setTotalVehicles(totalVehiclesCount);
        } else {
          console.error("Failed to fetch total number of Vehicles");
        }

        // Fetch total number of repport
        const responseReports = await fetch(
          `${backendUrl}/api/rapport/totalpage/${user_id}`,
          { mode: "cors" }
        );
        if (responseVehicles.ok) {
          const totalReportsData = await responseReports.json();
          const totalReportsCount = totalReportsData[0].total;
          setTotalReports(totalReportsCount);
        } else {
          console.error("Failed to fetch total number of Vehicles");
        }

        // Fetch total number of users
        const responseUsers = await fetch(
          `${backendUrl}/api/user/totalpage/${user_id}`,
          { mode: "cors" }
        );
        if (responseUsers.ok) {
          const totalUsersData = await responseUsers.json();
          const totalUsersCount = totalUsersData[0].total;
          setTotalUsers(totalUsersCount);
        } else {
          console.error("Failed to fetch total number of users");
        }


      } catch (error) {
        console.error("Error fetching data:", error);
      }


    };

    fetchData();
  }, [user_id]);



  // const fetchUserName = async (user_id: any) => {
  //   try {
  //     const response = await fetch(`${backendUrl}/api/getUserName/${user_id}`);
  //     if (response.ok) {
  //       const userData = await response.json();
  //       // Concatenate nom_user and username_user to form the userName
  //       const userName = `${userData.nom_user} ${userData.prenom_user}`;
  //       setUserName(userName);
  //     } else {
  //       console.error("Failed to fetch user data");
  //     }
  //   } catch (error) {
  //     console.error("Error fetching user data:", error);
  //   }
  // };

  // useEffect(() => {
  //   fetchUserName(user_id); // Add this line to fetch the user's name
  // }, [user_id]);


  const SOGChart: React.FC<{ data: Vehicle[] }> = ({ data }) => {
    // Extract unique immatriculation values
    const immatriculations = Array.from(
      new Set(data.map((vehicle) => vehicle.immatriculation_vehicule))
    );
    // Get current date
    const currentDate = new Date().toLocaleDateString();
    const chartData = immatriculations.map((immatriculation: string) => ({
      name: immatriculation,
      y:
        data.find(
          (vehicle) => vehicle.immatriculation_vehicule === immatriculation
        )?.SOG || 0,
    }));

    const options = {
      chart: {
        type: "column",
        zoomType: "x",
      },
      title: {
        text:
          translate("Diagram of distance, speed and contact") +
          " - " +
          `${currentDate}`,
      },
      xAxis: {
        categories: immatriculations,
        title: {
          text: translate("Vehicle"),
        },
      },
      yAxis: {
        title: {
          text: translate("Speed"),
        },
      },
      series: [
        {
          name: translate("Speed"),

          type: "column",
          data: chartData.map((point) => ({
            name: point.name,
            y: point.y,
            color: point.y === 0 ? "green" : point.y > 90 ? "red" : null, //
          })),
        },
      ],
    };

    return <HighchartsReact highcharts={Highcharts} options={options} />;
  };


  const getNotifications = async () => {
    try {
      // Prepare the request body
      const bodyData = JSON.stringify({
        id_user: user_id,
        state:1,
        limitValue: 10, // Limit the number of notifications to 10
      });

      // Make the fetch request
      const response = await fetch(`${backendUrl}/api/notification/count`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: bodyData,
        mode: "cors",
      });

      // Check if the response status is OK (status code 200)
      if (!response.ok) {
        throw new Error(`Request failed with status ${response.status}: ${response.statusText}`);
      }

      // Parse the JSON response
      const alarmResponse = await response.json();

      // Set the notifications state
      setNotifications(alarmResponse);
    } catch (error) {
      console.error("Error fetching alarms:", error);
      setNotifications([]);
      // Optionally show a message to the user
      // toast.error("An error occurred while fetching alarms. Please try again later.");
    }
  };

  // Fetch notifications when the component mounts or when the `user_id` or `state` changes
  useEffect(() => {
    if (user_id) {
      getNotifications();
    }
  }, [user_id]); // Add user_id and state to dependencies to fetch new notifications when they change


  const convertToVehicle = (data: VehicleData[]): Vehicle[] => {
    return data.map((vehicleData) => ({
      id_vehicule: 0, // Ajoutez l'ID du véhicule si nécessaire
      LAT: 0, 
      LON: 0,
      COG: 0,
      ENGINESTAT: 0,
      TIMESTAMP: "",
      GPSDIST: 0,
      ...vehicleData,
    }));
  };



  const [Driving, setDriving] = useState(0);
  const [Parking, setParking] = useState(0);
  const [ParkingEngineRunning, setParkingEngineRunning] = useState(0);
  const [LastTransmission, setLastTransmission] = useState(0);

  useEffect(() => {
    const getMarkers = () => {
  
      setTimeout(async () => {
        try {
          const response = await fetch(`${backendUrl}/api/map/find/${user_id}`);
          if (response.ok) {
            const data = await response.json();

            
            const startingVehicles = data.filter(
              (vehicle: Vehicle) => vehicle.ENGINESTAT === 1 && vehicle.SOG > 5
            );
            const parkingVehicles = data.filter(
              (vehicle: Vehicle) => vehicle.ENGINESTAT === 0
            );
            const runningVehicles = data.filter(
              (vehicle: Vehicle) => vehicle.ENGINESTAT === 1 && vehicle.SOG < 5
            );
            const filteredVehicles = data.filter((vehicle: Vehicle) => {
              const lastTransmissionHours = calculateHoursDifference(
                new Date().toISOString(),
                vehicle.TIMESTAMP
              );
              return lastTransmissionHours > 2;
            });

            // Mise à jour des états avec les données
            setDriving(startingVehicles.length);
            setParking(parkingVehicles.length);
            setParkingEngineRunning(runningVehicles.length);
            setLastTransmission(filteredVehicles.length);
          } else {
            console.error("Failed to fetch vehicle data");
          }
        } catch (error) {
          console.error("Error fetching vehicle data:", error);
        } finally {
          setLoading(false); 
        }
      }, 0); 
    };

    getMarkers();

    return () => {
      setLoading(false); 
    };
  }, []);


  function calculateHoursDifference(
    timestamp1: string,
    timestamp2: string
  ): number {
    const diffInMilliseconds =
      new Date(timestamp1).getTime() - new Date(timestamp2).getTime();
    return diffInMilliseconds / (1000 * 60 * 60);
  }
  const currentDate = new Date().toLocaleDateString();

  return (
    <>
      <div className="row">
        <div className="col-lg-4">
          <div className="card card-transparent card-block card-stretch card-height border-none">
            <div className="card-body p-0 mt-lg-2 mt-0">
              <h3 className="mb-3">
                {translate("Hello")}, {userName} {currentDate}{" "}
              </h3>

              <p
                style={{
                  marginBottom: "0",
                  marginRight: "20px",
                  fontSize: "16px",
                  lineHeight: "1.5",
                  color: "#333",
                  padding: "10px",
                  backgroundColor: "#f9f9f9",
                  borderRadius: "5px",
                  border: "1px solid #ccc",
                }}
              >
                {translate(
                  "Your dashboard monitors business processes. Fleet Management optimizes operations. Geotrackin provides location data, while ensuring real-time tracking."
                )}
              </p>
            </div>
          </div>
        </div>

        <div className="col-lg-8">
          <div className="row">
            <div className="col-lg-3 col-md-3">
              <FleetCounter
                numberOfItem={totalVehicles}
                title={translate("Vehicles")}
                icon={"car"}
                color={"bg-info-light"}
                linkTo="/vehicles" // Add the link here
              ></FleetCounter>
            </div>
            <div className="col-lg-3 col-md-3">
              <FleetCounter
                numberOfItem={totalDrivers}
                title={translate("Drivers")}
                icon={"user-tie"}
                color={"bg-danger-light"}
                linkTo="/drivers" // Add the link here
              ></FleetCounter>
            </div>
            <div className="col-lg-3 col-md-3">
              <FleetCounter
                numberOfItem={totalReports}
                title={translate("Reports")}
                icon={"chart-bar"}
                color={"bg-success-light"}
                linkTo="/reports" // Add the link here
              ></FleetCounter>
            </div>
            <div className="col-lg-3 col-md-3">
              <FleetCounter
                numberOfItem={totalUsers}
                title={translate("Users")}
                icon={"users-cog"}
                color={"bg-success-user"}
                linkTo="/users" // Add the link here
              ></FleetCounter>
            </div>
          </div>
        </div>
        <div className="col-lg-4">
          <FleetSate
            options={{
              DrivingValue: Driving,
              ParkingValue: Parking,
              ParkingEngineRunningValue: ParkingEngineRunning,
              LastTransmissionValue: LastTransmission,
            }}
          ></FleetSate>
        </div>
        {<div className="col-lg-8">
            <Notification type={"notifications"} Notifications={listNotifications} id={""}></Notification>
        </div>}
        <div className="col-lg-8">
          {/* <SOGChart data={convertToVehicle(dashData)} /> */}
        </div>
      
      </div>
    </>
  );
}
